<div class="container">
    <div class="row">
        <div class="col">
            <div class="text-center my-5">
                <h1 class="display-4 fw-bold text-primary">Vorteile</h1>
                <div class="border-bottom border-primary mx-auto" style="width: 100px; margin-top: 15px;"></div>
            </div>

            <div class="row my-5 align-items-center">
                <div class="col-md-7">
                    <div class="card border-0 shadow-sm h-100 p-4 bg-light">
                        <div class="card-body">
                            <h3 class="card-title text-primary mb-4">
                                <i class="fas fa-rocket mr-2"></i>Warum NoteRadar?
                            </h3>
                            <p class="card-text lead">
                                NoteRadar revolutioniert Ihr Dokumentenmanagement: Als Spezialist für Bescheid- und Vertragsdokumente bietet es Ihnen genau das, was Sie brauchen – ohne überflüssige Komplexität.
                            </p>
                            <p class="card-text">
                                Verwandeln Sie statische Dokumente in <strong>dynamische Arbeitsprozesse!</strong> Mit wenigen Klicks erstellen Sie maßgeschneiderte Aufgaben und weisen diese gezielt den richtigen Teams und Mitarbeitern zu.
                            </p>
                            <p class="card-text">
                                Das intelligente Terminsystem mit automatischen Erinnerungen sorgt dafür, dass <span class="text-danger">keine Frist mehr verpasst wird</span> – egal ob einmalige Aufgaben oder wiederkehrende Verpflichtungen. Schluss mit teuren Fristversäumnissen und stressigen Last-Minute-Aktionen!
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-md-5 text-center">
                    <img src="assets/img/benefits/1.png" class="img-fluid rounded shadow-lg" alt="NoteRadar Vorteile">
                </div>
            </div>

            <div class="row my-5">
                <div class="col-md-12">
                    <div class="card border-0 shadow-sm h-100 p-4 bg-light">
                        <div class="card-body">
                            <h3 class="card-title text-primary mb-4">
                                <i class="fas fa-piggy-bank mr-2"></i>Kostengünstig durch smarte Fokussierung
                            </h3>
                            <div class="row">
                                <div class="col-md-8">
                                    <p class="card-text">
                                        NoteRadar konzentriert sich gezielt auf die Funktionen, die Sie wirklich brauchen – ohne teure Extras, die niemand nutzt. Diese Effizienz spiegelt sich direkt in Ihren Kosten wider!
                                    </p>
                                    <p class="card-text">
                                        Mit einem Jahrespreis, der günstiger ist als 3 Stunden in einer KFZ-Vertragswerkstatt, bieten wir Ihnen <strong>maximalen Wert bei minimaler Investition</strong>.
                                    </p>
                                </div>
                                <div class="col-md-4">
                                    <div class="text-center p-3 bg-white rounded shadow-sm">
                                        <h4 class="text-success">Besonders attraktiv:</h4>
                                        <p>Die Lizenzkosten basieren ausschließlich auf der Anzahl Ihrer Betriebsstätten – unabhängig davon, wie viele Mitarbeiter die Plattform nutzen oder wie viele Dokumente Sie verwalten.</p>
                                        <div class="alert alert-success">
                                            <strong>Unbegrenztes Wachstum ohne versteckte Kosten!</strong>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row my-5 align-items-center">
                <div class="col-md-5 text-center">
                    <img src="assets/img/benefits/3.png" class="img-fluid rounded shadow-lg" alt="Sofort einsatzbereit">
                </div>
                <div class="col-md-7">
                    <div class="card border-0 shadow-sm h-100 p-4 bg-light">
                        <div class="card-body">
                            <h3 class="card-title text-primary mb-4">
                                <i class="fas fa-bolt mr-2"></i>Sofort einsatzbereit – ohne Installation, ohne Schulung
                            </h3>
                            <div class="alert alert-info">
                                Vergessen Sie komplizierte Software-Installationen und zeitraubende Schulungen! NoteRadar ist in Sekunden einsatzbereit.
                            </div>
                            <div class="row mt-4">
                                <div class="col-md-4 text-center mb-3">
                                    <div class="rounded-circle bg-primary text-white d-inline-flex justify-content-center align-items-center mb-3" style="width: 60px; height: 60px;">
                                        <i class="fas fa-laptop fa-2x"></i>
                                    </div>
                                    <h5>Einfacher Zugang</h5>
                                    <p>Öffnen Sie einfach Ihren Browser auf jedem Gerät und starten Sie sofort.</p>
                                </div>
                                <div class="col-md-4 text-center mb-3">
                                    <div class="rounded-circle bg-primary text-white d-inline-flex justify-content-center align-items-center mb-3" style="width: 60px; height: 60px;">
                                        <i class="fas fa-mobile-alt fa-2x"></i>
                                    </div>
                                    <h5>Flexibles Arbeiten</h5>
                                    <p>Das responsive Design passt sich automatisch jeder Bildschirmgröße an.</p>
                                </div>
                                <div class="col-md-4 text-center mb-3">
                                    <div class="rounded-circle bg-primary text-white d-inline-flex justify-content-center align-items-center mb-3" style="width: 60px; height: 60px;">
                                        <i class="fas fa-search fa-2x"></i>
                                    </div>
                                    <h5>Klare Struktur</h5>
                                    <p>Schneller Zugriff auf alle relevanten Informationen ohne Suchstress.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>
